import React from 'react';
import { cn } from '@skin-seoul/design-system';
import ProductImage from '../components/ProductImage';
import { DiscountBadge } from '../components/DiscountBadge';
import { CreditSealBadge } from '../components/CreditSealBadge';
import { CREDIT_SEAL_BADGE_INSET_PX, CREDIT_SEAL_BADGE_Z_INDEX } from '../components/creditSealBadgeVariants';
import { Condition } from '../../../utils/react/Condition';
import { useProductCard } from '../ProductCardContext';
import { isNil } from 'es-toolkit';

type ProductCardImageProps = {
  topSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
  className?: string;
  showCreditSeal?: boolean;
};

export const VerticalProductCardImage = ({
  topSlot,
  bottomSlot,
  className,
  showCreditSeal = true,
}: ProductCardImageProps) => {
  const { ranking } = useProductCard();
  return (
    <div
      className={cn(
        'rounded-[8px] bg-neutral-50 overflow-hidden h-[200px] tablet:h-[300px] max-h-[200px] tablet:max-h-[300px] box-border px-3 pt-[38px] pb-7 tablet:pt-9 tablet:px-3 tablet:pb-[30px] relative w-full min-w-0',
        className,
      )}
    >
      <div className="absolute z-[2] top-0 left-0 w-full flex">
        <>{topSlot}</>
      </div>
      <ProductImage />
      <Condition
        expression={!isNil(ranking)}
        then={
          <div className="absolute bottom-0 left-0 pb-[3px] h-12 w-12 flex items-center justify-center">
            <p className="text-neutral-200 text-heading-h2">{ranking}</p>
          </div>
        }
      />
      <DiscountBadge />
      {/* Seal takes the top-right so it never collides with the top-left discount badge. */}
      {/*
        Seal takes the top-right so it never collides with the top-left discount badge.
        The design changes variant at the tablet breakpoint, and the two variants have
        different typography, so each width renders its own element.
      */}
      {showCreditSeal && (
        <CreditSealBadge
          variant="s"
          className="absolute tablet:hidden"
          style={{
            top: CREDIT_SEAL_BADGE_INSET_PX.cardCompact,
            right: CREDIT_SEAL_BADGE_INSET_PX.cardCompact,
            zIndex: CREDIT_SEAL_BADGE_Z_INDEX,
          }}
        />
      )}
      {showCreditSeal && (
        <CreditSealBadge
          variant="m"
          className="absolute hidden tablet:block"
          style={{
            top: CREDIT_SEAL_BADGE_INSET_PX.cardDesktop,
            right: CREDIT_SEAL_BADGE_INSET_PX.cardDesktop,
            zIndex: CREDIT_SEAL_BADGE_Z_INDEX,
          }}
        />
      )}
      <div className="absolute bottom-0 z-[2] left-0 w-full flex justify-end">
        <>{bottomSlot}</>
      </div>
    </div>
  );
};
